import React, { Component } from 'react';
import { observer, Provider, inject } from 'mobx-react';
import { autorun } from 'mobx';
import { WallsStore } from './walls.store';
import { WallsComponent } from './walls.component';
import WallsForm from './walls.form';

@inject('livingRoomStore', 'appStore', 'routerStore')
@observer
export class WallsProvider extends Component {
    store;
    currentRoomNum;
    disabledEraZoneAutorun = false;
    disabledHydrateAutorun = false;

    constructor(props) {
        super(props);
        const { livingRoomStore, appStore, routerStore, match } = props,
            { history } = routerStore;

        appStore.setURLProps(match);
        appStore.clearError();

        this.currentRoomNum = parseInt(match.params.num, 10);
        livingRoomStore.currentRoomNum = this.currentRoomNum;

        this.store = new WallsStore({
            appStore,
            currentRoomNum: this.currentRoomNum
        });

        this.form = new WallsForm({
            store: this.store,
            appStore: appStore,
            currentRoomNum: this.currentRoomNum
        });

        this.disposeForm = autorun(() => {
            if (!this.disabledEraZoneAutorun) {
                this.setEraAndZone(appStore);
            }

            if (!appStore.loading && !this.disabledHydrateAutorun) {
                this.hydrateForm(appStore);
            }

            if (this.store.goNext) {
                this.store.goNext = false;

                // go to floor
                history.push({ pathname: `/livingroom/${this.currentRoomNum}/floor`, state: { transition: 'forward' } });
            }
        });
    }

    componentWillUnmount() {
        this.disposeForm();
    }

    /**
     * Update era and zone on all rvalue fields
     * @param appStore
     */
    setEraAndZone(appStore) {
        if (appStore.era && appStore.zone) {
            this.form.era = appStore.era;
            this.form.zone = appStore.zone;
            this.form.retrofitted2009 = appStore.retrofitted2009 === 'yes';
            this.form.standards2009Compliant = appStore.standards2009Compliant;
            this.form.rValueEra = appStore.rValueEra;

            this.form.setExtraProps({
                era: appStore.era,
                zone: appStore.zone,
                retrofitted2009: appStore.retrofitted2009 === 'yes',
                standards2009Compliant: appStore.standards2009Compliant,
                rValueEra: appStore.rValueEra
            });

            this.disabledEraZoneAutorun = true;
        }
    }

    /**
     * hydrate wall form data, adding windows and
     * doors before setting values
     * @param appStore
     */
    hydrateForm(appStore) {
        const roomKey = `room${this.currentRoomNum}`;
        let wallsData = null,
            wallNum = 0;

        if (
            !appStore.userData ||
            appStore.userData.rooms === undefined ||
            appStore.userData.rooms[roomKey] === undefined ||
            appStore.userData.rooms[roomKey].walls === undefined
        ) {
            return;
        }

        wallsData = appStore.userData.rooms[roomKey].walls;

        Object.keys(wallsData).forEach(fieldName => {
            if (/wall\d*/gi.test(fieldName) !== true) {
                return; // skip the current item (like continue but for forEach functions)
            }

            wallNum = parseInt(fieldName.match(/\d+/g)[0], 10);

            // add all walls, including re-adding the first
            this.addWallFields(wallNum);

            this.populateWindowsAndDoors(wallsData, fieldName, wallNum);
        });

        appStore.hydrateFormFields(
            appStore.userData.rooms[roomKey].walls,
            'walls',
            this.form
        );

        this.disabledHydrateAutorun = true;
    }

    populateWindowsAndDoors(wallsData, fieldName, wallNum) {
        // add windows and doors
        const wallData = wallsData[fieldName],
            path = `walls.wall${wallNum}`;

        let wallWindows = 0,
            wallDoors = 0;

        Object.keys(wallData).forEach(childName => {
            if (/wall\d*-windows/gi.test(childName) === true) {
                wallWindows = Object.keys(wallData[childName]).length;
            }

            if (/wall\d*-doors/gi.test(childName) === true) {
                wallDoors = Object.keys(wallData[childName]).length;
            }
        });

        if (wallWindows > 0) {
            for (let w = 1; w <= wallWindows; w += 1) {
                this.form.addWindow(wallNum, w, path);
            }
        }

        if (wallDoors > 0) {
            for (let d = 1; d <= wallDoors; d += 1) {
                this.form.addDoor(wallNum, d, path);
            }
        }
    }

    addWallFields(wallNum) {
        this.store.numWalls = wallNum;
        const wallFields = this.form.getWallFields();
        this.form.$('walls').add(wallFields);
    }

    render() {
        return (
            <Provider form={this.form} store={this.store}>
                <WallsComponent key='wall' />
            </Provider>
        );
    }
}
